var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-iframes main-page"},[_c('div',{staticClass:"container-flex"},[_c('iframe',{attrs:{"src":_vm.iframeSrc,"width":"100%","height":"100%","id":"ifra"}}),_c('div',{staticClass:"back-home",on:{"click":function($event){return _vm.$router.push('/')}}},[_c('img',{attrs:{"src":"/img/ui/back_home.png","alt":"","srcset":""}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }